import React, { Component } from 'react';
import { Popover, PopoverBody, Input, Collapse } from "reactstrap";
import uuid from "uuid/v4"


class Content extends Component {
    constructor(props) {
        super(props);
        this.state = { collapse: false };
        this.toggle = this.toggle.bind(this);
    }

    // render props?
    makeText(text) {
        return (
            <p key={uuid()} className="textContent">
                {text}
            </p>
        )
    }

    toggle(collapseID) {
        this.setState(({ [collapseID]: !this.state[collapseID] }));
    }

    makeHowCollapse(text) {
        let collapseID = text;
        return (
            <>
                <i className="fas fa-exclamation-circle" onClick={() => { this.toggle(collapseID) }} ></i>
                <Collapse isOpen={this.state[collapseID]}>
                    <a key={uuid()} className="collapseContent">
                        ->{text}
                    </a>
                </Collapse>
            </>
        )
    }

    makeList(listArray) {
        return (
            <ul key={uuid()}>
                {listArray.map(element => {
                    return (
                        <li key={uuid()}>
                            {element.text} {element.how ? this.makeHowCollapse(element.how) : null}
                        </li>
                    );
                })}
            </ul>
        )
    }

    makeExplanation(content, index) {
        let uniqueID = `popOver${index}`
        return (
            <div key={uuid()}>
                <p key={uuid()} className={"checkBoxText"}>
                    {content.text ? <>
                        <Input addon type="checkbox" aria-label="Checkbox for marking completion" defaultChecked={this.props.subscription.checkBoxes[this.props.getTimePeriod()][content.text]} onClick={e => { this.props.setCheckBox(content.text) }} />
                        {` ${content.text}`}</> : null}
                    <br />
                    <a key={uuid()} id={uniqueID} className="explanation">
                        {`   `}<u>{content.explanation.text}</u>
                    </a>
                </p>
                <Popover key={uuid()} placement="auto" isOpen={this.state[uniqueID]} target={uniqueID} toggle={() => {
                    // This code makes a more natural popOver dismiss
                    this.setState({ [uniqueID]: true })
                    let html = document.getElementsByTagName('html')[0];
                    // Self cleaning listener
                    let killListener = (e) => {
                        // If the target isnt a FA icon or the popover
                        if (e.target.tagName !== "I" && e.target.tagName !== "LI" && e.target.className !== "popover-body" && e.target.className !== "textContent" && e.target.className !== "collapseContent") {
                            this.setState({ [uniqueID]: false });
                            html.removeEventListener('click', killListener);
                        }
                    }
                    html.addEventListener("click", killListener)
                }}>
                    <PopoverBody key={uuid()}>
                        {this.makeContent(content.explanation.popOver)}
                    </PopoverBody>
                </Popover>
            </div>
        )
    }

    makeContent(content) {
        return content.map((element, index) => {
            if (element.explanation) {
                return (this.makeExplanation(element, index));
            }
            else if (element.text) {
                return (this.makeText(element.text));
            }
            else if (element.list) {
                return (this.makeList(element.list))
            }
        })
    }

    render() {
        if (this.props.data) {
            return (
                <>
                    {this.makeContent(this.props.data)}
                </>
            );

        }
        else return null;
    }
}

export default Content;